import firebase from "firebase";

const getApiBaseUrl = () => {
    const projectId = (firebase.app().options as any).projectId;
    if (!projectId) {
        throw new Error("Firebase project is not configured.");
    }

    if (
        typeof window !== "undefined" &&
        (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")
    ) {
        return `http://localhost:5001/${projectId}/us-central1/api`;
    }

    return `https://us-central1-${projectId}.cloudfunctions.net/api`;
}

const getErrorMessage = async (response: Response) => {
    try {
        const payload = await response.json() as { message?: string };
        if (payload?.message) {
            return payload.message;
        }
    } catch (error) {
    }

    return `Request failed with status ${response.status}`;
}

const getAuthToken = async () => {
    const currentUser = firebase.auth().currentUser;
    if (!currentUser) {
        throw new Error("Admin user is not authenticated.");
    }

    return currentUser.getIdToken();
}

const apiFetch = async (path: string, init: RequestInit = {}) => {
    const token = await getAuthToken();
    const response = await fetch(`${getApiBaseUrl()}${path}`, {
        ...init,
        headers: {
            "Authorization": `Bearer ${token}`,
            ...(init.headers || {})
        }
    });

    if (!response.ok) {
        throw new Error(await getErrorMessage(response));
    }

    return response;
}

const getJson = async <T>(path: string) => {
    const response = await apiFetch(path);
    return await response.json() as T;
}

const putJson = async <T>(path: string, body: any) => {
    const response = await apiFetch(path, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body || {})
    });

    return await response.json() as T;
}

const postJson = async <T>(path: string, body: any) => {
    const response = await apiFetch(path, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body || {})
    });

    return await response.json() as T;
}

const ApiService = {
    getApiBaseUrl,
    getErrorMessage,
    getJson,
    postJson,
    putJson
}

export default ApiService
